import { dashboardApi } from "@/lib/client/dashboard-api";
import type { Dashboard } from "@/types/dashboard";
import { useQuery } from "@tanstack/react-query";
import { useDelegation } from "./use-delegation";

export function useDashboards() {
  const { isDelegating, currentDelegation } = useDelegation();

  // Include delegation context in query key to ensure proper cache separation
  const queryKey =
    isDelegating && currentDelegation
      ? [
          "dashboards",
          {
            delegationType: currentDelegation.type,
            delegationId: currentDelegation.entityId,
          },
        ]
      : ["dashboards"];

  return useQuery({
    queryKey,
    queryFn: async (): Promise<Dashboard[]> => {
      const response = await dashboardApi.list({ pageSize: 100 });
      return response.dashboards;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}
